import { render, staticRenderFns } from "./PanelResumeVideo.vue?vue&type=template&id=15c05592&"
import script from "./PanelResumeVideo.vue?vue&type=script&lang=js&"
export * from "./PanelResumeVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports